import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import AddContact from "../../components/AddContact";
import { onPressAddContact } from "../../actions";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { Spin, Flex, Button, Divider } from "antd";
import AppContext from "../../components/AppContext";
import { generateCustomRanges } from "../../Data/CustomRangesData";
import DepositStatusBank from "../../components/Bank/depositStatusBank";
import WithdrawStatusBank from "../../components/Bank/withdrawStatusBank";
import { withTranslation } from "react-i18next";
import {
  AreaChartOutlined,
  DesktopOutlined,
  // QuestionCircleTwoTone,
} from "@ant-design/icons";
import TimeTableComponent from "../../helpers/timeTableComponent";
import { hasPermission, showToast } from "../../utils";
import Dashboard from "../../components/Dashboard/Dashboard";
import UpdateDataByRoute from "../../helpers/isUpdateDataByRoute";
// import MainTour from "./components/Tour";
import VerifyAccount from "../../components/Bank/VerifyAccount";
import Apisetting from "../../api/Apisetting";
import { getValidateMerchant } from "../../config/authsave";
import { FooterDashboard } from "../../components/Footer";
import i18next from "i18next";
// import StatusMeter from "../../components/StatusMeter/statusMeter";
// import { CalendarDateRangePicker } from "../../components/CalendarDateRangePicker";

class IoT extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      reportData: [],
      customRanges: [],
      tabKey: true,
      show: false,
      loadingtimeinterval: 0,
    };
    // 1. สร้าง Refs สำหรับองค์ประกอบเป้าหมายของ Tour
    this.tourRef1 = React.createRef();
    this.tourRef2 = React.createRef();
    this.tourRef3 = React.createRef();
    this.tourRef4 = React.createRef();
    this.tourRef5 = React.createRef();
    this.tourRef6 = React.createRef();
  }


  componentDidMount() {
    window.scrollTo(0, 0);
    const { t } = this.props;
    // เช็คว่าเคยดู Tour หรือยัง
    const hasSeenTour = localStorage.getItem("isTour");

    this.setState({
      customRanges: generateCustomRanges(t),
      show: !hasSeenTour // ถ้ายังไม่เคยดู (null) ให้โชว์ Tour ทันที
    }, () => this.fetchData());
  }
  fetchData = async () => {
    const { getActiveBankAccounts, setLoadingAccounts } = this.context;
    if (setLoadingAccounts) {
      setLoadingAccounts?.(true);
      getActiveBankAccounts();
    }
  };
  onUpdateAuto = async () => {
    const { activeAccountData } = this.context;
    let arrData = Array.isArray(activeAccountData) ? activeAccountData : [];
    let acc = arrData.filter((o) => o?.status_bank === "Active");
    if (this.state.tabKey && acc.length >= 1) {
      this.setState({ loading: false }, () => {
        this.fetchData();
      });
    } else {
      console.log("ไม่พบบัญชีที่เปิดใช้งานอยู่")
    }
  };

  // เมธอดสำหรับปิด Tour และบันทึกสถานะ
  onCloseTour = () => {
    // 1. ปิด Tour
    this.setState({ show: false });
    // 2. บันทึกสถานะลง localStorage
    localStorage.setItem("isTour", "1");
  };

  // เมธอดสำหรับเปิด Tour ใหม่ (ใช้กับปุ่ม 'Show Tour Again' ใน MainTour)
  onOpenTour = () => {
    this.setState({ show: true });
  };
  setTimeinterval = async (e, item) => {
    const { resProfileAdmin } = this.context;
    const { t } = this.props;

    const userPermissions = Array.isArray(resProfileAdmin?.permissions)
      ? resProfileAdmin.permissions
      : [];

    const accessible_setInterval = hasPermission(userPermissions, "setInterval");
    if (!accessible_setInterval) {
      return alert(t("คุณไม่มีสิทธิ์ในการตั้งค่าเวลา PULL INTERVAL"));
    }
    if (!item?.id && !e) return alert(t("No data"));
    const { fetchData } = this;
    this.setState({ loadingtimeinterval: item.id });
    let minutes = parseInt(e);

    let payload = {
      edit_id: item.id,
      types: "timeInterval",
      timeInterval: minutes,
      data: item,
      description: `ตั้งเวลาดึงยอดฝากเป็น ${minutes} ${t("minutes")}`,
    };
    try {
      const res = await Apisetting.postIsActiveBank(payload);
      if (res.status === 200) {
        showToast("success", res?.data?.message);
        setTimeout(() => {
          this.setState({ loadingtimeinterval: 0 }, () => fetchData());
        }, 1000);
      }
    } catch (error) {
      showToast("error", error?.message);
      this.setState({ loadingtimeinterval: 0 });
    }
  };
  render() {
    const { isContactModal, t } = this.props;
    const { tabKey, show, loadingtimeinterval } = this.state;
    const {
      activeAccountData,
      get_balance_summerys,
      loadingBankAccounts,
      handleReload,
      merchantId,
      spinnerID,
      enabled_verify_hub,
      averageTime,
      averageUpdateTime,
      resProfileAdmin,
      withdrawUsage,
      isMerchantData
    } = this.context;
    let { id } = getValidateMerchant();
    // const tourTargetRefs = {
    //   ref1: this.tourRef1,
    //   ref2: this.tourRef2,
    //   ref3: this.tourRef3,
    //   ref4: this.tourRef4,
    //   ref5: this.tourRef5,
    //   ref6: this.tourRef6,
    // };
    const { history } = this.props;
    const userPermissions = Array.isArray(resProfileAdmin?.permissions) ? resProfileAdmin.permissions : [];
    const canViewBalance = hasPermission(userPermissions, "view_balance_acc_payin_dashboard");
    const canViewDailySummary = hasPermission(userPermissions, "view_daily_summary_dashboard");
    const canViewDailySummaryPastTotals = hasPermission(userPermissions, "view_daily_summary_past_totals_dashboard");

    let { witdrow_minlimit, deposit_minlimit } = isMerchantData || {};
    // ดึงข้อมูล User มาแสดงผล

    const currentLanguage = i18next.language;
    let tFormat = currentLanguage;
    return (
      <>
        <div style={{ flex: 1 }}>
          <div style={{ opacity: isContactModal ? 0.3 : 1 }}>
            <div className="ng-star-inserted">
              <div className="container-fluid">
                <PageHeader
                  HeaderText={t("dashboard")}
                  Breadcrumb={[
                    {
                      name: removeSlashesFromPath(window.location.pathname),
                      navigate: window.location.pathname,
                    },
                  ]}
                />
                <UpdateDataByRoute onUpdateAuto={this.onUpdateAuto} />
                {/* <StatusMeter t={t} /> */}

                <br />
                <Divider />
                {/* 4. ส่ง Refs ไปให้ MainTour ผ่าน props */}
                {/* <MainTour
                  show={show}
                  targetRefs={tourTargetRefs}
                  onCloseTour={this.onCloseTour}
                  onOpenTour={this.onOpenTour} // เพิ่ม onOpenTour สำหรับปุ่มใน MainTour
                /> */}

                <Spin spinning={false}>
                  <Flex gap="small" wrap style={{ marginLeft: "10px" }}>
                    <Button
                      ref={this.tourRef1}
                      onClick={() => this.setState({ tabKey: true })}
                      variant={tabKey ? "solid" : "outlined"}
                      type={tabKey ? "primary" : "default"}
                    >
                      <DesktopOutlined /> {t("Bank account status")}
                    </Button>
                    {canViewDailySummary && (<Button
                      onClick={() => this.setState({ tabKey: false })}
                      variant={!tabKey ? "solid" : "outlined"}
                      type={!tabKey ? "primary" : "default"}
                    >
                      <AreaChartOutlined /> {t("Daily Summary")}
                    </Button>)}

                  </Flex>

                  {/* Dashboard */}
                  {!tabKey && (
                    <>
                      <div className={`mt-3`} ref={this.tourRef2}>
                        <Dashboard
                          merchantId={merchantId || parseFloat(id)}
                          activeKey={this.props.history.location.pathname}
                          key={tabKey}
                          t={t}
                          canViewDailySummaryPastTotals={canViewDailySummaryPastTotals}
                          tFormat={tFormat}
                        />
                      </div>
                    </>
                  )}
                  <br />
                  {/* <CalendarDateRangePicker /> */}
                  <div className="md-p-3 sm-p-0" ref={this.tourRef3}>
                    {tabKey && (
                      <TimeTableComponent
                        merchantId={merchantId || parseFloat(id)}
                        t={t}
                        show={show ? ["1"] : ["0"]}
                      />
                    )}
                  </div>
                  {/* สถานะบัญชี */}
                  {tabKey && (
                    <div className={`row clearfix status-dashboard-antd mt-3`}>
                      <div className="col-12">
                        <div className="row">
                          <div
                            className={`col-lg-6 col-md-6 col-sm-6 p-3 ${tabKey ? "in" : ""
                              }`}
                            ref={this.tourRef4}
                          >
                            <DepositStatusBank
                              get_balance_summerys={get_balance_summerys}
                              activeAccountData={activeAccountData}
                              handleReload={handleReload}
                              loadingBankAccounts={loadingBankAccounts}
                              spinnerID={spinnerID}
                              t={t}
                              setTimeinterval={this.setTimeinterval}
                              loadingtimeinterval={loadingtimeinterval}
                              canViewBalance={canViewBalance}
                              deposit_minlimit={deposit_minlimit}
                              tFormat={tFormat}
                            />
                          </div>
                          <div
                            className={`col-lg-6 col-md-6 col-sm-6 p-3 ${tabKey ? "out" : ""
                              }`}
                            ref={this.tourRef5}
                          >
                            <WithdrawStatusBank
                              activeAccountData={activeAccountData}
                              loadingBankAccounts={loadingBankAccounts}
                              get_balance_summerys={get_balance_summerys}
                              handleReload={handleReload}
                              spinnerID={spinnerID}
                              averageTime={averageTime}
                              averageUpdateTime={averageUpdateTime}
                              t={t}
                              withdrawUsage={withdrawUsage}
                              witdrow_minlimit={witdrow_minlimit}
                            />
                          </div>
                          <div
                            className={`col-lg-6 col-md-6 col-sm-6 p-3 ${tabKey ? "out" : ""
                              }`}
                            ref={this.tourRef6}
                          >
                            <VerifyAccount
                              activeAccountData={activeAccountData}
                              loadingBankAccounts={loadingBankAccounts}
                              enabled_verify_hub={enabled_verify_hub}
                              get_balance_summerys={get_balance_summerys}
                              handleReload={handleReload}
                              spinnerID={spinnerID}
                              history={history}
                              t={t}
                            />
                          </div>
                        </div>

                        <br />
                        {/* Footer */}
                        <FooterDashboard t={t} />
                      </div>
                    </div>
                  )}
                </Spin>
              </div>
            </div>
          </div>
          <AddContact />
        </div>
      </>
    );
  }
}
const mapStateToProps = ({ mailInboxReducer }) => ({
  isContactModal: mailInboxReducer.isContactModal,
});
export default connect(mapStateToProps, { onPressAddContact })(
  withTranslation()(IoT),
);
